// tables/index.ts
export * from "prosemirror-tables";
